// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ko-z","image":"Lo-z","lazyLoadPicture":"Mo-z","lazyLoadSpinner":"No-z","lazyLoadSpin":"Oo-z","lazyLoadImage":"Po-z","hasStyledAspectRatio":"Qo-z"};